<div class="offcanvas-container"
[class.is-open]="isOpen" 
     [class.side-right]="side === 'right'"
     [class.side-left]="side === 'left'">

  <button class="toggle-btn" title="{{TitelText}}"
          (click)="toggle()"
          [style.height]="btnHeight" [style.top]="btnTop">
    <i [class]="isOpen ? activeIconClass : iconClass"></i>
  </button>

  <div class="sidebar-content">
    <ng-content></ng-content>
  </div>
</div>

<div class="backdrop"
     *ngIf="isOpen"
     [@fadeInOut]
     (click)="toggle()">
</div>
